// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2255":"3b1e880a","4621":"bd7666f9","4795":"bd7666f9","5081":"bd7666f9","9238":"3b1e880a","9818":"bd7666f9"}[chunkId] + ".chunk.css";
};